import { API, FAIL_MESSAGE, PARAMS, SUCCESS_MESSAGE } from "../const/Emarsys";
import initForm, { queryString } from "./Forms";
import executeRecaptcha from "./Recaptcha";

function messageMarkup(message, icon) {
  const text = document.createTextNode(message).textContent;
  const icons = `fa fa-before fa-${icon}`;

  return `
    <p class="h4">
      <i class="${icons}"></i> ${text}
    </p>
  `;
}

const onFail = form => () => {
  const message = form.dataset.failMessage || FAIL_MESSAGE;

  form.innerHTML = messageMarkup(message, "exclamation-circle");
};

const onSuccess = form => () => {
  const message = form.dataset.successMessage || SUCCESS_MESSAGE;

  form.innerHTML = messageMarkup(message, "check-circle-o");
};

function submitEmarsysForm(form, { success = onSuccess(form), fail = onFail(form) }) {
  const { campaignId } = form.dataset;
  const inputs = [].slice.call(form.getElementsByTagName("input"));
  const nameValuePairs = (obj, input) => ({
    [input.name]: input.value,
    ...obj
  });
  const formParams = inputs.reduce(nameValuePairs, {});
  const qs = queryString({ ...PARAMS, ...formParams, f: campaignId });

  executeRecaptcha({
    success: () =>
      fetch(`${API}?${qs}`, { mode: "no-cors" })
        .then(success)
        .catch(fail),
    fail
  });
}

function isFormValid(form) {
  return form && form.dataset.campaignId;
}

function initEmarsysForm(
  form = document.querySelector("form[data-emarsys-form]"),
  eventHandlers = {},
  callbacks = {}
) {
  if (!isFormValid(form)) {
    return;
  }

  initForm(form, eventHandlers);

  form.addEventListener("submit", e => {
    e.preventDefault();
    submitEmarsysForm(form, callbacks);
  });
}

export default initEmarsysForm;



// WEBPACK FOOTER //
// ./utils/Emarsys.js